import { useMemo } from 'react';
import { useSelector } from 'react-redux';
// @ts-expect-error Untyped import
import { getAnalyticsToolsIA } from '../../config/analyticTools';
import { getGatesAndScopes } from '../../selectors/gatesSelector';
import { getCategoriesAndChildrenWithPermissions } from '../utils/categoryUtils';
import { selectReportCollectionTemplatesByKey } from '../../redux/reportCollectionTemplates';
export const useCategoryTemplates = () => {
  const {
    gates,
    scopes
  } = useSelector(getGatesAndScopes);
  const templatesByKey = useSelector(selectReportCollectionTemplatesByKey);
  const analyticsSuitesIA = useMemo(() => getAnalyticsToolsIA(gates, scopes).toJS(), [gates, scopes]);
  const suiteIdToCategories = useMemo(() => {
    const result = {};
    if (templatesByKey.size === 0) {
      return result;
    }
    analyticsSuitesIA.forEach(suite => {
      const categoryIA = suite.children;
      result[suite.id] = getCategoriesAndChildrenWithPermissions(categoryIA, gates, scopes, templatesByKey);
    });
    return result;
  }, [analyticsSuitesIA, templatesByKey, gates, scopes]);
  return suiteIdToCategories;
};